import React from "react";
import { Navigate,Outlet } from "react-router-dom";
import Header from "../common/component/Header";
import SideMenu from '../common/component/SideMenu'
import { LoaderProvider } from "../common/component/LoaderProvider";
import CommonLoader from "../common/component/commonLoader";
import {useSelector } from "react-redux";

const PrivateRoute = ({ children, isAuthenticated }) => {
  const valueStorage = JSON.parse(localStorage.getItem('token'));
  const isSuccess=JSON.parse(localStorage.getItem('isSuccess'));

  const resetPwdValue=useSelector((state)=>state.commonReducer.resetPwd)
  // && resetPwdValue===true
  return valueStorage && isSuccess==true && !resetPwdValue ? (
    <div className="app-layout">
       <LoaderProvider> 
      <Header />
      </LoaderProvider>
      <div className="content">
        <SideMenu />
        <div className="main-content-wrapper">
        <LoaderProvider> 
          {/* <CommonLoader />     */}
          <main className="main-content">
            <Outlet /> 
          </main>
        </LoaderProvider>
        </div>
      </div>
    </div>
  ) : (
    <Navigate to="/login" />
  );
};
export default PrivateRoute;

